import React from "react";
import { motion } from "framer-motion";
import "./Frame15.css";

function Frame15(props) {
  const { className } = props;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`frame-1-12 ${className || ""}`}
    >
      <div className="chart-name-44 poppins-bold-white-16px">Map</div>
      <div className="overlap-group2-33">
        <div className="ellipse-44-9"></div>
      </div>
    </motion.div>
  );
}

export default Frame15;
